import { CUSTOMER_JOURNEY_VENUES_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_VENUES_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyVenuesSuccess.js